<template>
  <div v-if="item.import" id="table-import-icon">
    <v-tooltip top max-width="200px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          color="softTextGrey lighten-2"
          class="ml-2 order-table-type-icon-import-icon"
          size="18"
          v-on="on"
        >
          mdi-file-upload-outline
        </v-icon>
      </template>
      <span>
        {{ $t(`views.common.orderTableTypeIcon.importFromFileAtDay`) }}
        {{ getDateUserFormat(item.import.createdAt) }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { getDateUserFormat } from '@/lib/utils/date.js'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getDateUserFormat,
  },
}
</script>

<style lang="scss">
#table-import-icon {
  .order-table-type-icon-import-icon {
    margin-bottom: 2px;
  }
}
</style>
